import { toFlatField } from '../oasis-types';
export const CoordinationOfCareVersioned = {
    physicianNotified: { e1: { alias: 'physicianNotified', timepoint: ['soc', 'roc'] } },
    clinicianName: { e1: { alias: 'clinicianName', timepoint: ['soc', 'roc'] } },
    collaboratorName: { e1: { alias: 'collaboratorName', timepoint: ['soc', 'roc'] } },
    nextVisitPlans: { e1: { alias: 'nextVisitPlans', timepoint: ['soc', 'roc'] } },
    coordinationDiscipline: { e1: { alias: 'coordinationDiscipline', timepoint: ['soc', 'roc'] } },
    coordinationName: { e1: { alias: 'coordinationName', timepoint: ['soc', 'roc'] } },
};
export const CoordinationOfCare = toFlatField(CoordinationOfCareVersioned);
